import AttachFileIcon from '@mui/icons-material/AttachFile';
import DeleteIcon from '@mui/icons-material/Delete';
import MusicVideoIcon from '@mui/icons-material/MusicVideo';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { IconButton, Paper, Tooltip } from "@mui/material";
import { getUploadUrl } from "../../service/ServiceApi";
import FolderZipIcon from '@mui/icons-material/FolderZip';

export default function AttachmentPreviewBox(props: { name: string; id: number | null; model: string; deleted?: boolean; file?: File, onDelete?: React.MouseEventHandler<HTMLButtonElement>, onClickImage?: () => void, systemAttachmentId?: number | null, systemAttachmentFile?: string | null }) {
    const { id, model, name, deleted, file, onDelete, onClickImage, systemAttachmentId, systemAttachmentFile } = props;
    let attachmentExt: string = (systemAttachmentFile || name).split('.').slice(-1)[0].toLowerCase();
    let iconSize = 40;
    let deleteIcon = null;
    if (onDelete && !deleted) {
        deleteIcon = <Tooltip sx={{ position: 'absolute', top: '-5px', right: '-5px', }} placement="top" title={'Remover anexo'}>
            <IconButton
                size='small'
                color="inherit"
                aria-label={'Remover anexo'}
                onClickCapture={onDelete}
            >
                <DeleteIcon style={{ fontSize: 24, color: 'red' }} />
            </IconButton>
        </Tooltip>;
    }

    let attachmentUrl = file
        ? URL.createObjectURL(file)
        : (systemAttachmentId && systemAttachmentFile)
            ? `${getUploadUrl()}SystemAttachment/${systemAttachmentId}/${systemAttachmentFile}`
            : `${getUploadUrl()}${model}/${id}/${name}`;
    if (['png', 'jpeg', 'jpg', 'gif', 'jfif'].includes(attachmentExt)) {
        return <Paper sx={{ padding: 1, height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#1f2937', position: 'relative' }} onClick={onClickImage}>
            {deleteIcon}
            <a style={{ display: 'flex', color: 'inherit', width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' }}>
                <img style={{ maxWidth: '100%', height: 'auto', maxHeight: '100%' }} src={attachmentUrl} />
            </a>
        </Paper>;
    } else if (attachmentExt === 'pdf') {
        return <Paper sx={{ padding: 1, height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#1f2937', position: 'relative' }}>
            <a style={{ display: 'flex', color: 'inherit', width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' }} href={attachmentUrl} target="_blank">
                <PictureAsPdfIcon style={{ fontSize: iconSize }} />
            </a>
        </Paper>;
    } else if (['txt', 'csv', 'xls', 'doc', 'docx'].includes(attachmentExt)) {
        return <Paper sx={{ padding: 1, height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#1f2937', position: 'relative' }}>
            {deleteIcon}
            <a style={{ display: 'flex', color: 'inherit', width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' }} href={attachmentUrl} target="_blank">
                <TextSnippetIcon style={{ fontSize: iconSize }} />
            </a>
        </Paper>;
    } else if (['mp4', 'wmv'].includes(attachmentExt)) {
        return <Paper sx={{ padding: 1, height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#1f2937', position: 'relative' }}>
            {deleteIcon}
            <a style={{ display: 'flex', color: 'inherit', width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' }} href={attachmentUrl} target="_blank">
                <OndemandVideoIcon style={{ fontSize: iconSize }} />
            </a>
        </Paper>;
    } else if (attachmentExt === 'mp3') {
        return <Paper sx={{ padding: 1, height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#1f2937', position: 'relative' }}>
            {deleteIcon}
            <a style={{ display: 'flex', color: 'inherit', width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' }} href={attachmentUrl} target="_blank">
                <MusicVideoIcon style={{ fontSize: iconSize }} />
            </a>
        </Paper>;
    } else if (attachmentExt === 'zip' || attachmentExt === 'rar') {
        return <Paper sx={{ padding: 1, height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#1f2937', position: 'relative' }}>
            {deleteIcon}
            <a style={{ display: 'flex', color: 'inherit', width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' }} href={attachmentUrl} target="_blank">
                <FolderZipIcon style={{ fontSize: iconSize }} />
            </a>
        </Paper>;
    }

    return <Paper sx={{ padding: 1, height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#1f2937', position: 'relative' }}>
        {deleteIcon}
        <a style={{ display: 'flex', color: 'inherit', width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' }} href={attachmentUrl} target="_blank">
            <AttachFileIcon style={{ fontSize: iconSize }} />
        </a>
    </Paper>;
}